import { format } from '@office-start/string-formatter-utility';
import { isNullOrWhitespace } from '../helpers/isNullOrWhitespace';
/**
 * TODO: Make this more flexible. Currently requires content for exactly 3 slides.
 */
export function generateGenericSlideGroup(slideGroupLocStrings, slideGroupImages, slideGroupIcons, userGreetingName, isSecondRun, secondRunSlideGroupLocStrings) {
    if (userGreetingName === void 0) { userGreetingName = ''; }
    var loc = slideGroupLocStrings;
    var secondRunLoc = secondRunSlideGroupLocStrings;
    var images = slideGroupImages;
    var icons = slideGroupIcons;
    var image1 = {
        light: "".concat(images[0], "_light"),
        dark: "".concat(images[0], "_dark"),
        highContrast: "".concat(images[0], "_hc"),
        format: 'svg',
    };
    function headline() {
        if (isSecondRun && secondRunLoc) {
            return secondRunLoc.slideHeadlineNoName;
        }
        else {
            if (isNullOrWhitespace(userGreetingName)) {
                return loc.slide1Headline;
            }
            else {
                return format(loc.slide1HeadlineWithUserName, userGreetingName);
            }
        }
    }
    var headline1 = headline();
    var title1 = loc.slide1Title;
    var highlights1 = [
        {
            text: loc.slide1Highlight1,
            icon: icons[0][0],
        },
        {
            text: loc.slide1Highlight2,
            icon: icons[0][1],
        },
        {
            text: loc.slide1Highlight3,
            icon: icons[0][2],
        },
    ];
    var slide1 = {
        image: image1,
        headline: headline1,
        title: title1,
        highlights: highlights1,
    };
    var image2 = {
        light: "".concat(images[1], "_light"),
        dark: "".concat(images[1], "_dark"),
        highContrast: "".concat(images[1], "_hc"),
        format: 'svg',
    };
    var headline2 = loc.slide2Headline;
    var title2 = loc.slide2Title;
    var highlights2 = [
        {
            text: loc.slide2Highlight1,
            icon: icons[1][0],
        },
        {
            text: loc.slide2Highlight2,
            icon: icons[1][1],
        },
        {
            text: loc.slide2Highlight3,
            icon: icons[1][2],
        },
    ];
    var slide2 = {
        image: image2,
        headline: headline2,
        title: title2,
        highlights: highlights2,
    };
    var image3 = {
        light: "".concat(images[2], "_light"),
        dark: "".concat(images[2], "_dark"),
        highContrast: "".concat(images[2], "_hc"),
        format: 'svg',
    };
    var headline3 = loc.slide3Headline;
    var title3 = loc.slide3Title;
    var highlights3 = [
        {
            text: loc.slide3Highlight1,
            icon: icons[2][0],
        },
        {
            text: loc.slide3Highlight2,
            icon: icons[2][1],
        },
        {
            text: loc.slide3Highlight3,
            icon: icons[2][2],
        },
    ];
    var slide3 = {
        image: image3,
        headline: headline3,
        title: title3,
        highlights: highlights3,
    };
    var slideGroup = isSecondRun
        ? [slide1, slide2]
        : [slide1, slide2, slide3];
    return slideGroup;
}
//# sourceMappingURL=generateGenericSlideGroup.js.map